import { PillCard } from '@playbooks/molecules/cards';
import { Card } from '@playbooks/ui/components/card';
const ImageAttachmentCard = ({ attachment, preview }) => (
	<Card className='aspect-[1/1] bg-surface border rounded-control h-14 overflow-hidden w-14'>
		{preview && <img src={preview} alt={attachment.name} className='h-full w-full object-cover' />}
	</Card>
);
const PDFAttachmentCard = ({ attachment, size }) => (
	<PillCard
		media={
			<div className='bg-danger border rounded-control text-foreground-inverse flex-middle shrink-0 text-xs font-bold h-8 w-8'>
				<span>PDF</span>
			</div>
		}
		title={attachment.name}
		text={size}
		className='flex-start h-12 w-64 max-w-64 gap-2 rounded-control border p-2 pr-7 hover:bg-surface'
	/>
);
const FileAttachmentCard = ({ attachment, size }) => (
	<PillCard
		icon='file'
		title={attachment.name}
		text={size}
		className='flex-start h-12 w-64 max-w-64 gap-2 rounded-control border p-2 pr-7 hover:bg-surface'
	/>
);
export { FileAttachmentCard, ImageAttachmentCard, PDFAttachmentCard };
